<template>
  <LeftSidebar
    :visible="visible"
    :title="$lang.attachment"
    bodyClass="overflow-y-hidden"
    titleClass="padding-x-16"
    :width="700"
    :hasFooter="false"
    @close="handleClose"
  >
    <div v-if="visible" class="height-percent-100 padding-16">
      <Attachments
        :label="$lang.attachments"
        uploaderName="activity"
        smBreakItem="6"
        lgBreakItem="6"
        :wrapperClass="wrapperClass"
        :shouldEditableAttachmentType="false"
        :AddAttachmentSidebarWidth="AddAttachmentSidebarWidth"
        :getListMethod="handleGetAttachments"
        :createMethod="handleCreateAttachment"
        :updateMethod="handleUpdateAttachment"
        :deleteMethod="handleDeleteAttachment"
      />
    </div>
  </LeftSidebar>
</template>

<script>
import { LeftSidebar } from "@/components/re-design";
import { Attachments } from "@/components/re-design";
import {
  centerExecuteActivityGetAttachments,
  centerExecuteActivityCreateAttachment,
  centerExecuteActivityUpdateAttachment,
  centerExecuteActivityDeleteAttachment,
} from "@/modules/kanoon/services";
import { toRefs } from "vue";

export default {
  components: { LeftSidebar, Attachments },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    AddAttachmentSidebarWidth: {
      type: [String, Number],
      default: null,
    },
    wrapperClass: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    // bind props
    const { visible, id } = toRefs(props);

    // bind emits
    const handleClose = () => emit("handleClose");

    const handleGetAttachments = async (page, perPage) => {
      try {
        const response = await centerExecuteActivityGetAttachments(
          id.value,
          page,
          perPage
        );
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleCreateAttachment = async (tempFiles) => {
      try {
        const response = await centerExecuteActivityCreateAttachment(
          id.value,
          tempFiles
        );
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleUpdateAttachment = async (
      attachmentCode,
      attachmentTypeId,
      attachmentCaption
    ) => {
      try {
        const response = await centerExecuteActivityUpdateAttachment({
          activityId: id.value,
          attachmentCode,
          attachmentTypeId,
          attachmentCaption,
        });
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleDeleteAttachment = async (attachmentCode) => {
      try {
        const response = await centerExecuteActivityDeleteAttachment(
          id.value,
          attachmentCode
        );
        return response;
      } catch (error) {
        generateError(error);
      }
    };

    // return data to be used in template
    return {
      visible,
      handleClose,
      handleGetAttachments,
      handleCreateAttachment,
      handleUpdateAttachment,
      handleDeleteAttachment,
    };
  },
};
</script>
